import DataManager from '../data/DataManager'

/**
 * アセット管理用クラス
 */
class AssetsMananger {

  // ---------------------------------------------------------------------------------------------------------
  // --	AssetsMananger
  // ---------------------------------------------------------------------------------------------------------

  /**
   * コンストラクタ
   */
  constructor() {}

  // ---------------------------------------------------------------------------------------------------------
  // --	読み込み
  // ---------------------------------------------------------------------------------------------------------

  /**
   * 初期化
   */
  async init() {
    await this.loadConfig();
    await this.loadAssets();
  }

  /**
   * Configファイル読み込み
   */
  loadConfig() {
    return new Promise((resolve, reject) => {
      //ローダー生成
      const loader = new PIXI.Loader();
      loader.add('config', './config.json');

      //エラーのハンドリング
      loader.onError.add(e => {
        console.log(e)
        reject('Configファイル読み込み失敗')
      })

      //読み込み
      loader.load((loader, resources) => {
        console.log(resources);
        this.config = resources.config.data;
        resolve()
      })
    })
  }

  /**
   * ページのAssets読み込み
   */
  loadAssets() {
    return new Promise((resolve, reject) => {
      //ローダー生成
      const loader = new PIXI.Loader();

      //素材読み込み
      loader.add('ssjson', 'assets/img/ss.json');

      //config.jsonに設定されたリソースを読み込む
      if(this.config.RESOURCES)
      {
        const len = this.config.RESOURCES.length
        for(let i=0; i<len; i++)
        {
          const resource = this.config.RESOURCES[i]
          loader.add(resource.id, resource.path);
        }
      }

      //エラーのハンドリング
      loader.onError.add(e => {
        console.log(e)
        reject('アセット読み込み失敗')
      })

      //読み込み
      loader.load((loader, resources) => {
        this.resources = resources
        resolve()
      })
    })
  }


  // ---------------------------------------------------------------------------------------------------------
  // --	取得
  // ---------------------------------------------------------------------------------------------------------

  /**
   * Config取得
   */
  getConfig(){
    return this.config;
  }


  // ---------------------------------------------------------------------------------------------------------
  // --	確認
  // ---------------------------------------------------------------------------------------------------------

  /**
   * リソースがあるかどうかの判定
   */
  hasResorce(name)
  {
    if(this.resources[name])
    {
      return true;
    }
    else
    {
      return false;
    }
  }

  // ----------------------------------------------------------------------------------------------------------------
  // --	取得関連
  // ----------------------------------------------------------------------------------------------------------------

  /**
   * テクスチャ取得
   */
  getTexture(name, antialiasing)
  {
    var texture = PIXI.Texture.fromFrame(name);
    texture.baseTexture.scaleMode = antialiasing? PIXI.SCALE_MODES.LINEAR:PIXI.SCALE_MODES.NEAREST;
    return texture;
  }

  /**
   * アニメーション取得
   */
  getAnimation(label)
  {
    return this.resources['ssjson'].data.animations[label];
  }

  /**
   * スプライト生成
   */
  createSprite(name, antialiasing = false)
  {
    return new PIXI.Sprite(this.getTexture(name, antialiasing));
  }

  /**
   * アニメーション作成
   */
  createMovieClipFromAnimation(label, antialiasing = false)
  {
    const frames = this.getAnimation(label);

    if(frames)
    {
      return this.createMovieClip(frames, antialiasing);
    }
    else
    {
      throw new Error('指定されたラベル名のアニメーションがありません');
    }
  }

  /**
   * ムービークリップ生成
   */
  createMovieClip(frames, antialiasing = false)
  {
    const textureArray = []
    for (let i = 0; i < frames.length; i++) {
      const texture = this.getTexture(frames[i], antialiasing);
      textureArray.push(texture)
    }
    return new PIXI.AnimatedSprite(textureArray);
  }

  /**
   * サウンドボタン生成
   */
  createSoundBtn(){
    return this.createMovieClip(['soundBtn_on', 'soundBtn_off']);
  }


  // ---------------------------------------------------------------------------------------------------------
  // --	サウンド
  // ---------------------------------------------------------------------------------------------------------

  playSound(name, loop = false, volume = 1)
  {
    if(!this.resources[name].sound) return
    const sound = this.resources[name].sound

    if(!sound.isPlaying || !sound.loop)
    {
      sound.loop = loop
      sound.volume = volume
      sound.play()
    }
    else
    {
      // console.log('再生中')
    }
  }

  stopSound(name)
  {
    if(!this.resources[name].sound) return
    const sound = this.resources[name].sound

    sound.stop()
  }

  stopAllSounds()
  {
    PIXI.sound.stopAll()
  }


  // ---------------------------------------------------------------------------------------------------------
}

export default new AssetsMananger()
